import SplitControl from '@/components/business/SplitControl'
import { MenuItemProps } from '@/resources/types'
import MenuItem from '../MenuItem'

const SplitControlledMenuItem = ({
  menuItem,
  onClick,
  isSubmenu = false,
}: MenuItemProps) => {
  return (
    <>
      {menuItem.featureFlag && menuItem.splitName ? (
        <SplitControl
          key={menuItem.id}
          splitName={menuItem.splitName}
          treatmentOff={null}
        >
          <MenuItem
            menuItem={menuItem}
            isSubmenu={isSubmenu}
            onClick={onClick}
          />
        </SplitControl>
      ) : (
        <MenuItem menuItem={menuItem} isSubmenu={isSubmenu} onClick={onClick} />
      )}
    </>
  )
}

export default SplitControlledMenuItem
